
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a20c2c56&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StsHeader.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./StsHeader.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-a20c2c56!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./StsHeader.vue"),
  /* scopeId */
  "data-v-a20c2c56",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/StsHeader.vue
// module id = 459
// module chunks = 1